import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'bil-bank-statement-dialog',
  templateUrl: './bank-statement-dialog.component.html',
  styleUrls: ['./bank-statement-dialog.component.sass']
})
export class BankStatementDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<BankStatementDialogComponent>) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

}
